<script setup>
import Auth from 'dashboard/api/auth';
import { useMapGetter } from 'dashboard/composables/store';
import Avatar from 'next/avatar/Avatar.vue';
import HubIndex from './HubIndex.vue';

import {
  DropdownContainer,
  DropdownBody,
  DropdownItem,
} from 'next/dropdown-menu/base';

const currentUser = useMapGetter('getCurrentUser');

const goToChat = () => {
  const accountId = currentUser.value?.account_id;
  if (accountId) {
    window.location.assign(`/app/accounts/${accountId}/dashboard`);
  }
};

const logout = () => {
  Auth.logout();
};
</script>

<template>
  <div class="w-full h-full flex flex-col" style="background: #f8fafc;">
    <header
      style="display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 10px 24px; background: #fff; border-bottom: 1px solid #e2e8f0;"
    >
      <RouterLink to="/app/hub" style="display: flex; align-items: center;">
        <img
          :src="'/brand-assets/wublo/logo-slogan-roxa.png'"
          alt="Wublo"
          style="height: 40px; width: auto;"
          class="dark:hidden"
        />
        <img
          :src="'/brand-assets/wublo/logo-slogan-branca.png'"
          alt="Wublo"
          style="height: 40px; width: auto;"
          class="hidden dark:block"
        />
      </RouterLink>

      <DropdownContainer>
        <template #trigger="{ toggle }">
          <button
            @click="toggle"
            style="display: flex; align-items: center; gap: 10px; cursor: pointer; background: transparent; border: 0;"
          >
            <Avatar
              :size="32"
              :name="currentUser.available_name"
              :src="currentUser.avatar_url"
            />
            <div style="text-align: left;">
              <div style="font-size: 14px; font-weight: 600; color: #0f172a;">
                {{ currentUser.available_name }}
              </div>
              <div style="font-size: 12px; color: #64748b;">
                {{ currentUser.email }}
              </div>
            </div>
            <span
              aria-hidden="true"
              class="i-lucide-chevron-down size-4 text-n-slate-10"
            />
          </button>
        </template>
        <DropdownBody class="z-50 min-w-56">
          <DropdownItem @click="goToChat">
            <template #label>
              <span class="text-n-slate-12">Chat</span>
            </template>
          </DropdownItem>
          <DropdownItem @click="logout">
            <template #label>
              <span class="text-n-slate-12">Sair</span>
            </template>
          </DropdownItem>
        </DropdownBody>
      </DropdownContainer>
    </header>

    <main class="flex-1 overflow-auto">
      <HubIndex />
    </main>
  </div>
</template>